import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import ScrollReveal from "scrollreveal";
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
      // スクロールリーバル
      window.sr = new ScrollReveal({duration: 600,mobile: false});
      function domEach(items, callback) {
          if (typeof items === "string") {
              var items = $(items);
          }

          for (var i = 0; i < items.length; i++) {
              var item = items[i];
              // callback = callback.bind(item)
              callback(i, item);
          }
      }
      sr.reveal(".c-main-visual__image", {scale: 1, duration: 600,distance: '10px',delay: 200}, 100);
      sr.reveal(".c-main-visual__text", {scale: 1, duration: 600,distance: '16px',origin: 'top',delay: 800}, 100);
      sr.reveal(".c-main-visual__subtext", {scale: 1, duration: 600,distance: '-10px',origin: 'top',delay: 1000}, 100);
      sr.reveal(".c-page-header", {scale: 1, duration: 600,distance: '0',delay: 200}, 100);
      sr.reveal(".c-opening,.c-card,.c-message", {scale: 1, duration: 600,distance: '0',delay: 400}, 100);
      sr.reveal(".c-bg-gray", {scale: 1, duration: 600,distance: '0',delay: 600,distance: '-10px',origin: 'top'}, 100);
      sr.reveal(".c-bg-white", {scale: 1, duration: 600,distance: '0',delay: 600,distance: '-10px',origin: 'top'}, 100);

      var blocks01 = $(".c-special__block,.c-voice__content");
      domEach(blocks01, function (key, item) {
          sr.reveal(item, {scale: 1,delay: 300,duration: 400,distance: '10px'}, 100);
          sr.reveal(item.children[1], {delay: 400, scale: 1,duration: 400,distance: '10px'}, 100);
          sr.reveal(item.children[2], {delay: 600, scale: 1,duration: 400,distance: '10px'}, 100);
          sr.reveal(item.children[3], {delay: 700, scale: 1,duration: 400,distance: '10px'}, 100);
          sr.reveal(item.children[4], {delay: 800, scale: 1,duration: 400,distance: '10px'}, 10);
          sr.reveal(item.children[5], {delay: 900, scale: 1,duration: 400,distance: '10px'}, 100);
          sr.reveal(item.children[6], {delay: 1000, scale: 1,duration: 400,distance: '10px'}, 100);
      });
      $(function() {
          var win = $(window).innerWidth();
          if (win > 750) {
              return false;
          }
          // フッターメニュー
          $('.c-footer-menu__title').on('click',function() {
              event.preventDefault();
              $(this).toggleClass('is-open');
              $(this).next(".c-footer-menu__list.is-sub").slideToggle();
          });
      });
    $(function() {
        var owls = $('.owl-carousel');
        if (owls.length === 0) {
            return false
        }
        owls.imagesLoaded(function () {
            $('.c-slider-office .owl-carousel').owlCarousel({
                items: 1,
                margin: 24,
                center: true,
                dots: true,
                loop: true,
                autoplayHoverPause: true,
                autoplay: true,
                autoplaySpeed: 500,
                responsive: {
                    0: {
                        autoWidth: false,
                    },
                    750: {
                        margin: 24,
                        autoWidth: true,
                    }
                }
            });
        });
    });
  }
}

window.GApp = new App();
